// The ghost car: a translucent copy of the car model (body + wheels at rest), no shadows.
import * as THREE from 'three/webgpu';
import type { CarSpec } from '../sim/types';
import type { CarView } from './car-view';
import type { GhostPose } from '../game/ghost';

export class GhostView {
  readonly root = new THREE.Group();
  private readonly material: THREE.MeshStandardNodeMaterial;

  constructor(car: CarView, spec: CarSpec) {
    this.root.name = 'ghost';
    this.material = new THREE.MeshStandardNodeMaterial({ color: 0xe6edf5, emissive: 0x334455, roughness: 0.45, metalness: 0, transparent: true, opacity: 0.33, depthWrite: false });
    // The model's body keeps its offset inside the car frame; the root carries the recorded pose.
    this.root.add((car.model?.body ?? car.body).clone(true));
    car.wheelSpinners.forEach((spinner, i) => {
      const w = spec.wheels[i];
      const travel = w.axle === 'front' ? spec.suspension.front.travel : spec.suspension.rear.travel;
      const wheel = spinner.clone(true);
      wheel.position.set(w.position[0], w.position[1] + travel * 0.5, w.position[2]);
      wheel.rotation.set(0, 0, 0);
      this.root.add(wheel);
    });
    this.root.traverse((o) => {
      const m = o as THREE.Mesh;
      if (!m.isMesh) return;
      m.material = this.material;
      m.castShadow = false;
      m.receiveShadow = false;
      m.renderOrder = 2;
    });
    this.root.visible = false;
  }

  setPose(p: GhostPose): void {
    this.root.position.set(p.x, p.y, p.z);
    this.root.quaternion.set(p.qx, p.qy, p.qz, p.qw);
  }
}
